import halfLeaveImg from "@assets/img/halfleavelogo.svg";
import halfLeaveBg from "@assets/img/halfleavevector.svg";
import leaveImg from "@assets/img/leave.svg";
import leaveBg from "@assets/img/totalleavesvector.svg";
import lateArrivalImg from "@assets/img/clock.svg";
import lateArrivalBg from "@assets/img/latearrivalvector.svg";
import punctualImg from "@assets/img/avatar.svg";
import punctualBg from "@assets/img/punctualvector.svg";
import {
  getMonthAndYear,
  getEmployeeData,
  sortByTime,
  getCurrentMonthLeaves,
} from "@utils/utils.js";
import { TALHA_EMP_ID } from "@utils/constants.js";
import _ from "lodash";

export const getAnalyticData = ({ attendance, employees, leaves }) => {
  const currentMonthLeaves = getCurrentMonthLeaves(leaves, attendance[0]?.date);
  const formattedDate = getMonthAndYear(new Date());
  const { leavesCount, lateArrivalCount, halfLeavesCount, mostPunctual } =
    getDashboardData(attendance, employees, currentMonthLeaves);

  return [
    {
      title: "Total Leaves",
      label: "full-leaves",
      date: formattedDate,
      analytics:
        leavesCount == 1 ? leavesCount + " Leave" : leavesCount + " Leaves",
      image: leaveImg,
      bgImage: leaveBg,
    },
    {
      title: "Total Half Leaves",
      label: "half-leaves",
      date: formattedDate,
      analytics: halfLeavesCount + " Half Leave",
      image: halfLeaveImg,
      bgImage: halfLeaveBg,
    },
    {
      title: "Total Late Arrivals",
      label: "late-arrivals",
      date: formattedDate,
      analytics: lateArrivalCount + " Lates",
      image: lateArrivalImg,
      bgImage: lateArrivalBg,
    },
    {
      title: "Most Punctual",
      label: "punctual",
      date: formattedDate,
      analytics: mostPunctual.name || "Developer",
      designation: mostPunctual.job || "No Job Title",
      image: mostPunctual.image || punctualImg,
      bgImage: punctualBg,
    },
  ];
};

function getDashboardData(attendance, employees, leaves) {
  if (!attendance || !attendance.length > 0) {
    return {
      leavesCount: 0,
      lateArrivalCount: 0,
      halfLeavesCount: 0,
      mostPunctual: {},
    };
  }
  const leavesCount = getLeavesCount(leaves);
  const halfLeavesCount = getHalfLeavesCount(leaves);
  const lateArrivalCount = getLateArrivalCount(attendance);
  const mostPunctual = getMostPunctual(attendance, employees);
  return { leavesCount, lateArrivalCount, halfLeavesCount, mostPunctual };
}

const getLeavesCount = (leaves) => {
  return _.reject(leaves, (leave) => {
    return (
      leave.status === "rejected" ||
      leave.status === "exempted" ||
      leave.no_of_days == -0.5
    );
  }).length;
};

const getHalfLeavesCount = (leaves) => {
  return _.filter(leaves, { no_of_days: -0.5 }).length;
};

const getLateArrivalCount = (attendance) => {
  return _.filter(
    attendance,
    (atten) => atten.status === "Late" && !atten.exempt
  ).length;
};

const getMostPunctual = (attendance, employees) => {
  if (!employees || !employees.length > 0) return {};
  attendance = _.reject(
    attendance,
    (emp) =>
      emp.status == "Full leave" ||
      emp.absent == "True" ||
      !emp.clock_In ||
      emp.employee_id == TALHA_EMP_ID
  );

  attendance = sortByTime(attendance);
  attendance = _.groupBy(attendance, "date");

  const punctualList = [];
  for (let emp in attendance) {
    punctualList.push(attendance[emp][0]);
  }

  attendance = _.values(_.groupBy(punctualList, "employee_id"));
  const punctualEmp = _.max(attendance);
  const { name, job, image } = getEmployeeData(
    employees,
    punctualEmp[0].employee_id
  );

  return { name, job, image };
};
